import React from 'react'

const UserPlanSkeleton = () => (
  <div className="bg-background-secondary flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md">
    <div className="flex animate-pulse flex-col gap-7 px-5 pb-5 lg:gap-10 ">
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div>
      </div>
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div>
      </div>
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div>
      </div>
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div>
      </div>
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div>
      </div>
    </div>
  </div>
)

export default UserPlanSkeleton
